import { render, staticRenderFns } from "./CredentialComponent.vue?vue&type=template&id=0a58aa9c"
import script from "./CredentialComponent.vue?vue&type=script&lang=js"
export * from "./CredentialComponent.vue?vue&type=script&lang=js"
import style0 from "./CredentialComponent.vue?vue&type=style&index=0&id=0a58aa9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports